// removed by extract-text-webpack-plugin
module.exports = {"RestartSubscriptionDialog__question":"_1DpYr-xrlT_XM7B2WNyp1p","RestartSubscriptionDialog__question-centered":"_3GqJ6DbZY169IQ7p11BbUM","RestartSubscriptionDialog__plan":"_27UCpI-ZnhY_cIBUTY7kr9","RestartSubscriptionDialog__plan-value":"_3vslBli0Yb04yM8qgyZbUc","RestartSubscriptionDialog__buttons":"_2HTb3jXR85U12DkB7VyZJt","RestartSubscriptionDialog__button":"_3L8crffbRJZ9oViqcjLKUU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RestartSubscriptionDialog/RestartSubscriptionDialog.scss
// module id = 2684
// module chunks = 0